const FormatsDate: string[] = [
    'DD MMMM YYYY',
    'DD MMMM YY',
    'DD MMM YYYY',
    'DD MMM YY',
    'DD.MM.YYYY',
    'DD.MM.YY',
    'DD/MM/YYYY',
    'DD/MM/YY',
    'DD-MM-YYYY',
    'DD-MM-YY',
    'MMMM DD YYYY',
    'MMMM DD YY',
    'MMM DD YYYY',
    'MMM DD YY',
    'MM.DD.YYYY',
    'MM.DD.YY',
    'MM/DD/YYYY',
    'MM/DD/YY',
    'MM-DD-YYYY',
    'MM-DD-YY'
];

export default FormatsDate;